import { CurrencyType } from "@bitwarden/web-vault/app/models/types/location-currency.types";

export type ScopeValue =
  | "api" // legaci @deprecated
  | "offline_mode" // legaci @deprecated
  | "GLOSS"
  | "VAULT"
  | "VIEWS"
  | "DATA_AGGREGATOR"
  | "FOREX"
  | "EQUITY"
  | "BETA_ACCESS";

export type Scope = ScopeValue[];

// Define specific types for arrays
type DataAggregatorConnectorName = "BASIQ" | "PLAID";
type GlossView = "scenario" | "summary" | "combined";
type EquityInterval = "month" | "day" | "week" | "year";
type ForexInterval = "month" | "day" | "week" | "year";

// Define the claim interface
export interface RoleClaim {
  data_aggregator_connector_name: DataAggregatorConnectorName[];
  equity_interval: EquityInterval;
  forex_currency: CurrencyType[];
  forex_interval: ForexInterval;
  gloss_subscription_store: string;
  gloss_subscription_tier: "free" | "premium" | "enterprise";
  gloss_views: GlossView[];
  gloss_views_size: number;
  market_data_exchanges: string[];
  vault_size_limit: number;
}

// Array-valued fields default to [] since consumers dereference them with array methods
// (.includes/.slice) and may read the claim before setClaims() runs. Scalar fields default
// to null explicitly (rather than being left off the object) so the shape always matches
// RoleClaim without needing an `as RoleClaim` cast to suppress missing-property checks.
const DEFAULT_ROLE_CLAIM: RoleClaim = {
  data_aggregator_connector_name: [],
  equity_interval: null,
  forex_currency: [],
  forex_interval: null,
  gloss_subscription_store: null,
  gloss_subscription_tier: null,
  gloss_views: [],
  gloss_views_size: null,
  market_data_exchanges: [],
  vault_size_limit: null,
};

// Now update your RoleAccessData class to use this type
export class RoleAccessData {
  private scope: Scope = [];
  private claim: RoleClaim = { ...DEFAULT_ROLE_CLAIM };

  getScope() {
    return this.scope;
  }

  setScope(scopes: Scope) {
    this.scope = scopes;
  }

  getClaim(): RoleClaim {
    return this.claim;
  }

  setClaims(claims: RoleClaim) {
    // Merge over the defaults, not over the previous claim: state.service#getRoleClaim() can
    // resolve to `{}`/undefined (token response omitted roleClaim, or RoleAccessService
    // .initialise() runs before any login has populated it), and RoleAccessService.initialise()
    // calls this unconditionally on every session init - including re-inits for a different
    // account. Merging onto this.claim would let an incoming partial/empty claim inherit
    // whichever fields the previous session's claim held, leaking entitlements across accounts
    // or across a mid-session downgrade. Merging onto the defaults resets omitted fields every
    // time, while still keeping the array defaults that guard the unguarded-dereference crash.
    this.claim = { ...DEFAULT_ROLE_CLAIM, ...claims };
  }

  clearClaims() {
    this.claim = { ...DEFAULT_ROLE_CLAIM };
  }
}
